import { render, staticRenderFns } from "./EditRoleForm.vue?vue&type=template&id=268aaa54&scoped=true"
import script from "./EditRoleForm.vue?vue&type=script&lang=js"
export * from "./EditRoleForm.vue?vue&type=script&lang=js"
import style0 from "./EditRoleForm.vue?vue&type=style&index=0&id=268aaa54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268aaa54",
  null
  
)

export default component.exports